import React from 'react'
import PropTypes from 'prop-types'

export function Undo({ size = '1rem', colour = 'currentColor', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={{
        width: size,
        minWidth: size,
        height: 'auto'
      }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12.666 5.46855L9.99935 8.13521H11.9993C11.9993 10.3419 10.206 12.1352 7.99935 12.1352C7.32602 12.1352 6.68602 11.9685 6.13268 11.6685L5.15935 12.6419C5.97935 13.1619 6.95268 13.4685 7.99935 13.4685C10.946 13.4685 13.3327 11.0819 13.3327 8.13521H15.3327L12.666 5.46855ZM3.99935 8.13521C3.99935 5.92855 5.79268 4.13521 7.99935 4.13521C8.67268 4.13521 9.31268 4.30188 9.86602 4.60188L10.8393 3.62855C10.0193 3.10855 9.04601 2.80188 7.99935 2.80188C5.05268 2.80188 2.66602 5.18855 2.66602 8.13521H0.666016L3.33268 10.8019L5.99935 8.13521H3.99935Z"
        fill={colour}
      ></path>
    </svg>
  )
}

Undo.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.any
}
